import { render, staticRenderFns } from "./AddConfigSetting.vue?vue&type=template&id=62083c8e&scoped=true&"
import script from "./AddConfigSetting.vue?vue&type=script&lang=js&"
export * from "./AddConfigSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62083c8e",
  null
  
)

export default component.exports